import { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { updateReview } from "../../stores/actions/review.actions.types";
import { useParams } from "react-router-dom";
import { BiLoaderAlt } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { SelectInput, TextInput } from "../UI/FormField";
import History from "../../stores/services/history";

const UpdateReviewForm = ({ updateReview, ReviewData }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  console.log("list update proudct id ==== ", id);

  const statusOptions = [
    { value: "pending", key: t("pending") },
    { value: "approved", key: t("approved") },
  ];

  const validationSchema = Yup.object().shape({
    ProductName: Yup.string().required(t("product-name-required")),
    review: Yup.string().required(t("review-required")),
    rating: Yup.number().required(t("rating-required")),
    status: Yup.string().required(t("status-required")),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    console.log("list update value == ", values);
    const callback = (data) => {
      if (data.success) {
        setLoading(false);
        History.navigate("/reviews");
      } else {
        setLoading(false);
      }
    };
    updateReview({ id, data: values, callback });
  };

  return (
    <div className='rounded-[10px] border border-stroke bg-white p-4 shadow-1 dark:border-dark-3 dark:bg-boxdark dark:shadow-card sm:p-7.5'>
      <div className='max-w-full  overflow-x-auto'>
        <Formik
          enableReinitialize
          initialValues={{
            ProductName: ReviewData?._id ? ReviewData?._id : "",
            review: ReviewData?.comment ? ReviewData?.comment : "",
            rating: ReviewData?.rating ? ReviewData?.rating : "",
            status: ReviewData?.status ? ReviewData?.status : "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange, isSubmitting, setFieldValue }) => (
            <Form className='mx-auto space-y-4 rounded-md p-2 shadow-md'>
              <div className='grid grid-cols-1 gap-x-4 md:grid-cols-2'>
                {["ProductName", "review", "rating"].map((field) => (
                  <TextInput
                    key={field}
                    label={t(field)}
                    id={field}
                    name={field}
                    type={"text"}
                    placeholder={t(`placeholder-${field}`)}
                    disabled={true}
                    className='block w-full text-black dark:text-white rounded-md border px-3 py-2 dark:bg-black'
                  />
                ))}

                <SelectInput
                  label={t("status")}
                  id='status'
                  name='status'
                  default={ReviewData?.status}
                  options={statusOptions.map((status) => ({
                    value: status.value,
                    key: status.key,
                  }))}
                  className='block w-full text-black dark:text-white rounded-md border px-3 py-2 dark:bg-black'
                />
              </div>
              <button
                type='submit'
                disabled={loading || isSubmitting}
                className='w-full bg-red-600 text-white py-2 rounded-md'
              >
                {loading ? (
                  <BiLoaderAlt className='animate-spin text-2xl m-auto  text-white' />
                ) : (
                  t("Update Review")
                )}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });
export default connect(mapStateToProps, { updateReview })(UpdateReviewForm);
